import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function CalendarIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15 2H13V0H10V2H6V0H3V2H1C0.448 2 0 2.448 0 3V15C0 15.552 0.448 16 1 16H15C15.552 16 16 15.552 16 15V3C16 2.448 15.552 2 15 2ZM14 14H2V5H14V14Z" />
        <path d="M6 7H4V9H6V7Z" />
        <path d="M9 7H7V9H9V7Z" />
        <path d="M6 10H4V12H6V10Z" />
        <path d="M9 10H7V12H9V10Z" />
        <path d="M12 7H10V9H12V7Z" />
        <path d="M12 10H10V12H12V10Z" />
      </svg>
    </Icon>
  );
}
